"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelIcon = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../entities/contracts/constants");
const airbnb_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/airbnb.svg"));
const booking_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/booking.svg"));
const expedia_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/expedia.svg"));
const holidu_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/holidu.svg"));
const hometogo_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/hometogo.svg"));
const vrbo_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/vrbo.svg"));
const tripadvisor_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/tripadvisor.svg"));
const travelnest_logo_nest_svg_1 = __importDefault(require("../../../71eb904/assets/images/channels/travelnest-logo-nest.svg"));
const channelIcons = {
    [constants_1.Channel.AIRBNB]: airbnb_svg_1.default,
    [constants_1.Channel.BOOKINGCOM]: booking_svg_1.default,
    [constants_1.Channel.EXPEDIA]: expedia_svg_1.default,
    [constants_1.Channel.HOLIDU]: holidu_svg_1.default,
    [constants_1.Channel.HOMEAWAY]: vrbo_svg_1.default,
    [constants_1.Channel.HOMETOGO]: hometogo_svg_1.default,
    [constants_1.Channel.TRIPADVISOR]: tripadvisor_svg_1.default,
    [constants_1.Channel.TRAVELNEST]: travelnest_logo_nest_svg_1.default,
};
const IconWrapper = styled_1.default.div `
	display: inline-block;

	img {
		height: 40px;
		width: 40px;
	}
`;
const ChannelIcon = (props) => {
    const { channel } = props;
    return React.createElement(IconWrapper, null,
        React.createElement("img", { src: channelIcons[channel] }));
};
exports.ChannelIcon = ChannelIcon;
//# sourceMappingURL=ChannelIcon.js.map